<c-container class="pt-3">
  <c-row class="mb-3">
    
    <c-col *ngIf="screenTitle">
      <h3 class="chart-header-row__title">
        <!-- {{model == 1 ? 'Department' : 'Regional'}} Average Utilisation Score  -->
        {{screenTitle}} Live Utilisation
      </h3>
    </c-col>
    
  </c-row>
  <!-- <c-row class="mb-3">
    <c-card>
      <c-card-body>
        <app-filter-panel></app-filter-panel>
      </c-card-body>
    </c-card>
  </c-row> -->
  <c-row>
    <c-col class="col-lg-9">
      <c-card>
        <c-card-header class="card-header">
          <h4 class="card-header__heading">
            {{screenTitle}} Utilisation Score (This week)</h4>
        </c-card-header>
        <c-card-body>
          <c-chart [data]="weeklyChartData" type="bar" (chartRef)="handleChartRef($event)"
            [options]="weeklyChartOptions" height="450" />
        </c-card-body>
      </c-card>
    </c-col>
    <c-col class="col-lg-3">
      <c-row>
        <c-col class="col-lg-12">
          <c-card>
            <c-card-header class="card-header">
              <h4 class="card-header__heading">
                Utilisation Breakdown (this week)</h4>
            </c-card-header>
            <c-card-body>
              <c-chart [data]="vehicleUtilizationData " type="doughnut" (chartRef)="handleChartRef($event)"
                [options]="vehicleUtilizationOptions" height="200" />

            </c-card-body>
          </c-card>
        </c-col>

      </c-row>
      <c-row class="mt-3">
        <c-col class="col-lg-12">
          <c-card>
            <c-card-header class="card-header">
              <h4 class="card-header__heading">
                Unused Reasons</h4>
            </c-card-header>
            <c-card-body>
              <c-chart [data]="vehicleStatusData " type="doughnut" (chartRef)="handleChartRef($event)"
                [options]="vehicleStatusOptions" height="200" />
            </c-card-body>
          </c-card>
        </c-col>
      </c-row>
    </c-col>
  </c-row>
  <c-row class="mt-3">
    <c-col>
      <c-card>
        <c-card-header class="card-header">
          <c-row class="mt-3">
             <c-col xs="7">
              <h4 class="card-header__heading mb-3">Depot Live Vehicle status list</h4>
              <span class="card-header__date-range">
                <app-date-range-label  [model]="rangeSelectorValue" [options]="dateRangeOptions" (modelChange)="handleRouteFilterChange($event)" />
              </span>

              <button class="d--f ai--c auto-refresh-btn mt-2" cButton color="light" (click)="toggleAutoRefresh()"><span class="auto-refresh-btn__text">{{autoRefreshEnabled ? 'Stop' : 'Start' }} auto data refresh </span>
                <svg class="ml-3 auto-refresh-btn__icon" [cIcon]="autoRefreshIcon" size="lg" title="Stop/start auto refresh"></svg>
                <br><small class="auto-refresh-btn__date">(Last updated: {{dataUpdateDateStamp | date: 'dd-MM-yyyy HH:mm:ss'}})</small> </button>

            </c-col>
            <c-col xs="5">

              <app-current-utilisation-score-widget
                [snapshot]="todaySnapshot"
                [title]="'Today\'s Utilisation Score'"
                [subTitle]="todaySnapshotSubTitletext"
                ></app-current-utilisation-score-widget>
            </c-col>
          </c-row>

        </c-card-header>
        <c-card-body>
          <c-smart-table
            #smartTable="cSmartTable"
            [columnSorter]="true"
            [itemsPerPage]="vehicleUtilisationListPageSize"
            [columns]="columns"
            [columnFilter]="{ external: true, lazy: true }"
            [items]="vehicleUtilisationList"
            [clickableRows]="true"
            (rowClick)="handleRowClick($event)"
            [loading]="vehicleUtilisationListLoading"
            [tableProps]="{ hover: true, striped: true, responsive: true }"
            (columnFilterValueChange)="vehicleUtilisationFilterValueChange($event)"
            header
          >
            <ng-template cTemplateId="columnLabel_all" let-column>
              <div class="d-inline">
                {{ column.label }}
                <ng-container *ngTemplateOutlet="icon; context: {$implicit: column}"></ng-container>
              </div>
            </ng-template>

            <ng-template
              cTemplateId="tableData"
              let-columnName="columnName"
              let-item="item"
              let-tdContent="tdContent"
            >
              <td
                [ngClass]="smartTable.getTableDataCellClass(item, columnName)"
              >
                @switch (columnName) {
                  @case ('is_utilized' || 'is_vor') {
                    <c-badge [color]="getBadge(tdContent, item['is_vor'])">
                      {{ getUtilisationStatus(item)}}
                    </c-badge>

                    <c-badge class="ml-xsmall" color="danger" *ngIf="item['is_vor']">VOR</c-badge>
                  }
                  @case ('snapshot_date') {
                    {{tdContent | date: 'dd/MM/yyyy' }}
                  }
                  @case ('last_utilization_change_datetime') {
                    {{tdContent ? (tdContent | date: 'dd-MM-yyyy HH:mm') : '-' }}
                  }
                  @case ('details') {
                    <svg [cIcon]="icons.cilArrowCircleRight" size="lg" title="List Icon"></svg>
                  }
                  @case ('last_entered_geofence_entry_time') {
                    {{tdContent ? (tdContent | date: 'dd-MM-yyyy HH:mm') : '-' }}
                  }
                  @case ('last_entered_geofence_exit_time') {
                    {{tdContent ? (tdContent | date: 'dd-MM-yyyy HH:mm') : '-' }}
                  }
                  @default {
                    {{ tdContent ? tdContent : '-'}}
                  }
                }
              </td>
            </ng-template>
          </c-smart-table>
          <c-smart-pagination
            *ngIf="vehicleUtilisationListTotalPages"
            [activePage]="vehicleUtilisationListPage"
            (activePageChange)="loadVehicleUtilisationListPage($event)"
            [pages]="vehicleUtilisationListTotalPages"
          />
          <ng-template #icon let-column>
            @if (column?._data?.tooltip) {
              <div class="d-inline"
                   [cTooltipTrigger]="'hover'"
                   [cTooltip]="column?._data?.tooltip"
                   cTooltipPlacement="top"
              >
              </div>
            }
          </ng-template>


          <app-status-flyout [(visible)]="isFlyoutVisible" (visibleChange)="flyoutEventChanged($event)" [snapshot]="selectedSnapshot"></app-status-flyout>

        </c-card-body>
      </c-card>
    </c-col>

  </c-row>

</c-container>

<!-- <c-offcanvas placement="end" id="OffcanvasEnd" style="width: 600px;">
  <c-offcanvas-header>
    <h5 cOffcanvasTitle>Offcanvas Header</h5>
    <button cButtonClose class="text-reset ms-auto" cOffcanvasToggle="OffcanvasEnd" aria-label="Close"></button>
  </c-offcanvas-header>
  <c-offcanvas-body>
    <div class="container mt-4">

      <div class="d-flex justify-content-between align-items-center">
        <h3>Status Activity - YG70TSV</h3>
        <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#vehicleStatusContent"
          aria-expanded="false">
          collapse <i class="fas fa-chevron-up"></i>
        </button>
      </div>

      <div id="vehicleStatusContent" class="collapse show">

        <c-row>
          <label for="vehicleStatus" class="mr-2">Update Vehicle Status</label>
        </c-row>
        <c-row>
          <c-col class="form-group">
            <select id="vehicleStatus" class="form-control mr-2" style="width: 150px;">
              <option>Status</option>
              <option>Available</option>
              <option>VOR</option>
              <option>At Repairer</option>
            </select>
          </c-col>
          <c-col>
            <input type="text" class="form-control mr-2" placeholder="Add Notes..." style="width: 200px;">

          </c-col>
          <c-col>
            <button class="btn btn-success">Update Status</button>

          </c-col>
        </c-row>
        <c-row>
          <div>
            Updating by: <strong>Bob Smith</strong>
          </div>
        </c-row>

        <h5 class="mt-3">Vehicle Utilisation Status</h5>
        <table class="table table-striped">
          <thead class="thead-light">
            <tr>
              <th>Date</th>
              <th>Status</th>
              <th>VOR Reason</th>
              <th>Notes</th>
              <th>Link</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>06/02/2024</td>
              <td>At Repairer</td>
              <td></td>
              <td>At Trustford</td>
              <td></td>
            </tr>
            <tr>
              <td>05/02/2024</td>
              <td>VOR</td>
              <td>Defect</td>
              <td>#012-23543</td>
              <td><a href="#">view</a></td>
            </tr>
            <tr>
              <td>04/02/2024</td>
              <td>Available</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>

        <h5>Vehicle Activities</h5>
        <table class="table table-striped">
          <thead class="thead-light">
            <tr>
              <th>Date</th>
              <th>Status</th>
              <th>VOR Reason</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>06/02/2024</td>
              <td>Safety Inspection</td>
              <td></td>
              <td>At Trustford</td>
            </tr>
            <tr>
              <td>05/02/2024</td>
              <td>Defect</td>
              <td>Defect</td>
              <td>#012-23543</td>
            </tr>
            <tr>
              <td>04/02/2024</td>
              <td>Defect</td>
              <td>Steering</td>
              <td></td>
            </tr>
          </tbody>
        </table>

        <div class="card mb-3">
          <div class="card-body">
            <p><strong>Last Updated:</strong> 19/07/2024 13:00</p>
            <h5>Live Location</h5>
            <p><strong>Location:</strong> Address, City, Postcode</p>
            <p><strong>Key Event:</strong> Driving</p>
            <button class="btn btn-success" style="    position: absolute;
            top: 10px;
            right: 10px;">Get Live Location</button>
          </div>
        </div>


        <div class="d-flex justify-content-around">
          <button class="btn btn-primary">Track Vehicle</button>
          <button class="btn btn-secondary">Trace Vehicle</button>
        </div>
      </div>
    </div>

  </c-offcanvas-body>
</c-offcanvas> -->
